import * as React from 'react'
import { DsBox, DsImage } from '@am92/react-design-system'

// constants
import { LIGHT_MONEY_GROW_ASSET, NRI } from '~/src/Constants/ASSET_MAP'
import APP_ROUTES from '../Constants/APP_ROUTES'
import withErrorConnect from '../Lib/withErrorConnect'
import { getSubsequentLoginNativeDisplayEvents } from '../Redux/AppState/Selectors'
import { TAppStore } from '../Configurations/AppStore'
import { getThemeReducer } from '../Redux/Theme/Selectors'
import { T_THEME_REDUCER } from '../Redux/Theme/TYPES'

export interface IWebLeftContentProps {
  subSequentLoginPayloadFromCT: any
  theme: T_THEME_REDUCER
}

class WebLeftContent extends React.Component<IWebLeftContentProps> {
  render() {
    const { subSequentLoginPayloadFromCT, theme: {
      scheme
    } } = this.props;

    const url = window.location.href
    const pathname = new URL(url).pathname

    let formattedImage: any = LIGHT_MONEY_GROW_ASSET

    if (pathname.includes('NRI')) {
      formattedImage = NRI
    } else if (pathname === APP_ROUTES.SUBSEQUENT_LOGIN_CHALLENGE_PASSWORD.pathname) {

      const { payload } = subSequentLoginPayloadFromCT ?? {};

      if (payload) {
        try {
          const json = JSON.parse(payload);
          const { image } = json

          const isDarkTheme = scheme === 'dark'
          const currentThemeKey = isDarkTheme ? 'dark' : 'light'

          const targetImageUrl = image?.[currentThemeKey]

          if (targetImageUrl) {
            formattedImage = [{
              src: targetImageUrl,
              alt: 'Subsequent Login Image',
              as: 'image/png'
            }]
          }
        } catch (error) {
          console.error('Invalid JSON from CT payload', error)
        }
      }
    }

    return (
      <DsBox
        sx={{
          position: 'relative',
          display: { lg: 'flex', md: 'flex', xs: 'none' },
          width: '40%'
        }}
      >
        <DsImage
          srcSet={formattedImage}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </DsBox>
    )
  }
}

const mapStateToProps = (state: TAppStore) => {
  const subSequentLoginPayloadFromCT = getSubsequentLoginNativeDisplayEvents(state);
  const theme = getThemeReducer(state)

  return {
    subSequentLoginPayloadFromCT,
    theme
  }
}

const mapDispatchToProps = () => ({
  actions: {}
})

export default (withErrorConnect(mapStateToProps, mapDispatchToProps)(WebLeftContent))